<template>
  <div>
    <v-card elevation="1" max-width="90%" class="profile-data">
      <v-card-text>
        <div
          class="mb-4"
          v-if="edit == false"
          :class="locale == 'en' ? 'text-right' : 'text-left'"
        >
          <v-btn class="primary-btn edit-btn" @click="openEditMode()">
            {{ $t("Edit Details") }}
          </v-btn>
        </div>

        <div class="details">
          <v-form v-model="valid" ref="form">
            <v-row class="details-table">
              <v-col cols="12" sm="3">
                <p class="main-color">
                  <strong>{{ $t("Card Type") }}</strong>
                </p>
              </v-col>
              <v-col
                cols="12"
                sm="9"
                v-if="edit == false && payment.payment_method == 'visa'"
              >
                <v-img src="../assets/images/visa.jpg" width="70px"></v-img>
              </v-col>
              <v-col
                cols="12"
                sm="9"
                v-if="edit == false && payment.payment_method == 'mastercard'"
              >
                <v-img
                  src="../assets/images/mastercard.png"
                  width="70px"
                ></v-img>
              </v-col>
              <v-col
                cols="12"
                sm="9"
                v-if="edit == false && payment.payment_method == 'mada'"
              >
                <v-img src="../assets/images/mada.png" width="70px"></v-img>
              </v-col>

              <v-col cols="12" sm="9" v-if="edit == true">
                <label for="paymentMethod" class="capitalize"
                  >{{ $t("paymentMethod") }} *</label
                >
                <v-radio-group v-model="updateObject.payment_method" row>
                  <v-radio :label="$t('visa')" value="visa" class="mb-4">
                    <template v-slot:label>
                      <img
                        src="../assets/images/visa.jpg"
                        width="100px"
                        alt="visa"
                        class="payment-img"
                      />
                    </template>
                  </v-radio>
                  <v-radio
                    :label="$t('masterCard')"
                    value="mastercard"
                    class="mb-4"
                  >
                    <template v-slot:label>
                      <img
                        src="../assets/images/mastercard.png"
                        width="100px"
                        alt="Visa"
                        class="payment-img"
                      />
                    </template>
                  </v-radio>
                  <v-radio :label="$t('mada')" value="mada" class="mb-4">
                    <template v-slot:label>
                      <img
                        src="../assets/images/mada.png"
                        width="100px"
                        alt="Visa"
                        class="payment-img"
                      />
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <!--  -->
            <v-row class="details-table">
              <v-col cols="12" sm="3">
                <p class="main-color">
                  <strong>{{ $t("cardNumber") }}</strong>
                </p>
              </v-col>
              <v-col cols="12" sm="9" v-if="edit == false">
                <p>{{ payment.card_number }}</p>
              </v-col>
              <v-col cols="12" sm="9" v-if="edit == true" class="input-td">
                <v-text-field
                  solo
                  v-model="updateObject.card_number"
                  :rules="[
                    validationRules.required,
                    validationRules.numeric,
                    validationRules.maxLength16
                  ]"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="details-table">
              <v-col cols="12" sm="3">
                <p class="main-color">
                  <strong>{{ $t("ccv") }}</strong>
                </p>
              </v-col>
              <v-col cols="12" sm="9" v-if="edit == false">
                <p>{{ payment.cvc }}</p>
              </v-col>
              <v-col cols="12" sm="9" v-if="edit == true">
                <v-text-field
                  v-model="updateObject.cvc"
                  :rules="[
                    validationRules.required,
                    validationRules.numeric,
                    validationRules.maxLength3
                  ]"
                  solo
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="3">
                <p class="main-color">
                  <strong>{{ $t("cardName") }}</strong>
                </p>
              </v-col>
              <v-col cols="12" sm="9" v-if="edit == false">
                <p>{{ payment.card_holder_name }}</p>
              </v-col>
              <v-col cols="12" sm="9" v-if="edit == true" class="input-td">
                <v-text-field
                  v-model="updateObject.card_holder_name"
                  solo
                  :rules="[
                    validationRules.required,
                    checkcardName(updateObject.card_holder_name)
                  ]"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="3">
                <p class="main-color">
                  <strong>{{ $t("Expired Date") }}</strong>
                </p>
              </v-col>
              <v-col cols="12" sm="9" v-if="edit == false">
                <p>{{ payment.exp_year }} / {{ payment.exp_month }}</p>
              </v-col>
              <v-col
                cols="12"
                sm="9"
                v-if="edit == true"
                style="padding-top: 0"
              >
                <v-row>
                  <v-col style="padding-top: 0">
                    <label for="month" class="capitalize"
                      >{{ $t("month") }} *</label
                    >
                    <v-select
                      v-model="updateObject.exp_month"
                      :items="months"
                      :rules="[
                        validationRules.required,
                        checkDate(updateObject.exp_year, updateObject.exp_month)
                      ]"
                      solo
                    ></v-select>
                  </v-col>
                  <v-col style="padding-top: 0">
                    <label for="year" class="capitalize"
                      >{{ $t("year") }} *</label
                    >
                    <v-select
                      v-model="updateObject.exp_year"
                      :items="years"
                      :rules="[
                        validationRules.required,
                        checkDate(updateObject.exp_year, updateObject.exp_month)
                      ]"
                      solo
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row v-if="edit == true">
              <v-col :class="locale == 'en' ? 'text-right' : 'text-left'">
                <v-btn
                  class="primary-btn"
                  @click="update"
                  :loading="loading"
                  :disabled="loading"
                  >{{ $t("Update") }}</v-btn
                >
                <v-btn class="gray-btn" @click="cancelEdit">
                  {{ $t("Cancel") }}</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from "../mixins/validationMixin";

export default {
  name: "studentPayment",
  mixins: [validationMixin],
  props: ["payment", "dataObject"],
  data() {
    return {
      loading: false,
      valid: false,
      validationErrors: [],
      updateObject: {
        payment_method: "",
        card_number: "",
        cvc: "",
        card_holder_name: "",
        exp_year: "",
        exp_month: ""
      },
      edit: false,
      str: "",

      nowDate: new Date(Date.now() - 864e5).toISOString().slice(0, 10),
      /* datepicker */
      date: new Date().toISOString().substr(0, 10),
      menu2: false,
      // teacherOrStudent: AUTH.teacherOrStudent()

      years: [],
      months: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12"
      ]
    };
  },
  methods: {
    generateYears() {
      const currentYear = new Date().getFullYear();
      for (let i = currentYear; i <= currentYear + 8; i++) {
        this.years.push(i);
      }
    },
    onFocus() {
      this.validationErrors = [];
    },
    openEditMode() {
      this.edit = true;
      this.fillEditObject();
    },
    cancelEdit() {
      this.edit = false;
    },
    fillEditObject() {
      this.updateObject = {
        payment_method: this.payment.payment_method,
        card_number: this.payment.card_number,
        cvc: this.payment.cvc,
        card_holder_name: this.payment.card_holder_name,
        exp_year: Number(this.payment.exp_year),
        exp_month: this.payment.exp_month
      };
    },
    update() {
      if (this.valid == false) {
        this.validate();
      } else {
        this.loading = true;
        this.$http
          .post(this.getApiUrl + "/student/profileData", this.updateObject, {
            headers: {
              locale: localStorage.locale,
              Authorization: "Bearer " + localStorage.token
            }
          })
          .then(Response => {
            this.loading = false;
            // emit update to parent
            if (
              Object.keys(Response.data.status.validation_errors).length > 0
            ) {
              this.validationErrors = Response.data.status.validation_errors;
            } else {
              this.$emit(
                "updated",
                Response.data.status.error,
                Response.data.status.message
              );
              this.cancelEdit();
            }
          });
      }
    }
  },
  mounted() {
    this.generateYears();
    if (this.openEdit == true) {
      this.openEditMode();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/_variables.scss";
@import "../assets/styles/_responsive.scss";

.profile-data {
  margin-top: 4rem;
  margin-bottom: 4rem;
  padding: 2rem;
  .primary-btn {
    background-color: $main-color !important;
  }
  .details-table {
    td {
      min-width: 200px;
      padding-bottom: 2rem;
    }
  }
}
</style>
